import { IExistingDebt } from '@common/interfaces/existingDebt'
import { IInventoryAppraisal } from '@common/interfaces/inventoryAppraisal'
import { ILcrBoardMember } from '@common/interfaces/lcrBoardMember'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import * as actions from './actions'

export default combineReducers({
  // Existing Debt and Board Members refetch their list on success (from the
  // component), so only the list drives the stored data — create/update/delete
  // stay pure requests.
  existingDebt: createLoadingDataReducer<IExistingDebt[]>([actions.LIST_EXISTING_DEBT_REQUEST]),
  boardMembers: createLoadingDataReducer<ILcrBoardMember[]>([
    actions.LIST_LCR_BOARD_MEMBERS_REQUEST,
  ]),
  // Both GET and UPLOAD feed the appraisal: GET on mount, UPLOAD after
  // extraction. Wiring UPLOAD as a loading trigger (not a saving one) is what
  // makes its SUCCESS payload — the freshly-extracted DTO — replace the tables
  // in place.
  inventoryAppraisal: createLoadingDataReducer<IInventoryAppraisal>([
    actions.GET_INVENTORY_APPRAISAL_REQUEST,
    actions.UPLOAD_INVENTORY_APPRAISAL_REQUEST,
  ]),
})
